<template>
  <el-table-column :label="label" :prop="prop" class-name="transferred" :sortable="sortable">
    <template slot-scope="scope"  v-if='transferred(scope.row, scope.$index)'>
      <i class="el-icon-check"></i>
    </template>
  </el-table-column>
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '繰越'
    },
    prop: {
      type: String,
      default: 'transferred'
    },
    sortable: {
      type: Boolean,
      default: false
    },
    transferred: {
      type: Function,
      default: () => false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.transferred {
      width: 6em;
    }
  }
  // .transferred .el-tag {
  //   width: 2.5em;
  //   text-align:center;
  //   color: #409eff;
  //   background-color: #ecf5ff;
  //   border-color: #d9ecff;
  //   font-weight: bold;
  // }
}
</style>
